import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { BulkCallCampaignStatus } from "types/Models/broadcastCall";
import { BroadcastCallExport } from "./BroadcastCallExport";
import { CancelScheduleBroadcastCall } from "./CancelScheduleBroadcastCall";
import { Button } from "components/DesignSystem/Button/Button";
import ThreeDots from "static/images/ThreeDots.svg";
import { useModal } from "hooks/useModal";
import { BULK_CALL_CAMPAIGN_STATUSES } from "constants/broadcast";

export const BroadcastCallOptions = ({
  broadcastCallId,
  campaignStatus,
}: {
  broadcastCallId: string;
  campaignStatus: BulkCallCampaignStatus;
}) => {
  const cancelModal = useModal();

  return (
    <>
      <Dropdown.Root>
        <Dropdown.Trigger asChild>
          <div>
            <Button size="xsmall" customType="ghost_icon">
              <img src={ThreeDots} alt="Action" className="t-select-none" />
            </Button>
          </div>
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content
            className="!t-w-32 !t-min-w-32"
            sideOffset={4}
            align="start"
            side="bottom"
            alignOffset={-112}
          >
            {campaignStatus === BULK_CALL_CAMPAIGN_STATUSES.SCHEDULED && (
              <Dropdown.Item onSelect={cancelModal.open}>Cancel</Dropdown.Item>
            )}
            <BroadcastCallExport broadcastCallId={broadcastCallId} />
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
      <CancelScheduleBroadcastCall
        broadcastCallId={broadcastCallId}
        {...cancelModal}
      />
    </>
  );
};
